import * as log from 'loglevel';
var Base = /** @class */ (function () {
    function Base(_meetingStartRequest, _communicationHandler) {
        this.meetingStartRequest = _meetingStartRequest;
        this.communicationHandler = _communicationHandler;
        this.onObjectCreated();
    }
    Base.prototype.onObjectCreated = function () {
        log.info("Object created");
    };
    Base.prototype.cleanup = function () {
        this.communicationHandler = undefined;
        this.meetingStartRequest = undefined;
        log.info("cleanup");
    };
    return Base;
}());
export { Base };
